<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 16 10"
  >
    <path
      fill="#122033"
      fill-rule="evenodd"
      d="M11.31 9.83a.432.432 0 0 1 0-.586l3.32-3.855H.4c-.22 0-.4-.186-.4-.414 0-.228.18-.415.4-.415h14.23L11.315.705c-.145-.176-.16-.42-.005-.58.155-.16.425-.17.57-.005 0 0 3.96 4.508 4 4.56.04.051.12.145.12.295s-.08.254-.12.295c-.04.042-4 4.56-4 4.56a.398.398 0 0 1-.57 0z"
    />
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      default: 16
    },
    height: {
      default: 10
    }
  }
};
</script>
